import MailchimpSubscribe from "react-mailchimp-subscribe";

import SubscribeForm from "./subscribeForm";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const MailchimpForm = () => {
  return (
    <div className="mc__form-container">
      <MailchimpSubscribe
        url={CONSTANTS.mailChimpPostUrl}
        render={({ subscribe, status, message }) => (
          <SubscribeForm status={status} message={message} onValidated={(formData) => subscribe(formData)} />
        )}
      />
    </div>
  );
};

export default MailchimpForm;
